import { T }    from 'defa-object';
/**
 * defa.views.ErrorView
 * A generic ErrorView, displaying messages.
 * @version 1.2.1
 */
import View     from 'scripts/poppet/view';
import template from 'templates/errorView.jst.html';


const selectors = {
	closeButton: '[data-click=error-close]',
};
const ErrorView = View.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,
	className: 'card error',
	
	ui:{
		close   : selectors.closeButton,
	},
	
	events: {
		'click @ui.close'  : 'onClickClose',
		
	},
	
	templateContext: function () {
		return {
			title  : this.getTitle(),
			message: this.getMessage(),
			hasCloseButton : this.hasClose() || '',
		};
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	onClickClose: function(){
		this.trigger('close', this)
	},
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Triggers when the view is attached to the DOM.
	 * @void
	 */
	hasClose: function(){
		return this.options.closeLink || '';
	},
	
	
	getMessage: function () {
		return !!this.model && this.model.get( 'message' )
			   || this.options.message
			   || '';
	},
	
	getTitle: function () {
		return !!this.model && this.model.get( 'title' )
			   || this.options.title
			   || T.tc( 'ErrorView', 'Error' );
	}
	
} );

export default ErrorView;